import * as React from 'react';
import { Button } from '@ai-content-hub/content-kit';
import { Plus, Loader2 } from 'lucide-react';
import { usePromptTranslations } from '../i18n';

export interface UploadButtonProps {
    onClick: () => void;
    disabled?: boolean;
    uploading?: boolean;
}

export const UploadButton: React.FC<UploadButtonProps> = ({
    onClick,
    disabled = false,
    uploading = false,
}) => {
    const pt = usePromptTranslations();
    return (
    <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        disabled={disabled || uploading}
        onClick={onClick}
        className="prompt-description-upload-button z-10 text-muted-foreground/60 hover:text-foreground hover:bg-muted/60"
        style={{
            position: 'absolute',
            top: 8,
            right: 8,
        }}
        title={pt.uploadDocument}
        aria-label={pt.uploadDocument}
    >
        {uploading ? (
            <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
            <Plus className="h-4 w-4" />
        )}
    </Button>
    );
};
